define(function (require, exports, module) {
    'use strict';

    var dateTime = require('lib/dateTime');

    /**
     * @constructor
     * @param {Error} stack – ошибка для быстрой навигации по коду.
     * @param {string} source – источник проблемы: backend, web-backend, web-client.
     */
    function UploadReason(stack, source) {
        if (!(this instanceof UploadReason)) {
            throw new TypeError(UploadReason.ERROR_WRONG_INSTANCE);
        }

        if (this.constructor === UploadReason) {
            throw new TypeError(UploadReason.ERROR_ABSTRACT_CLASS);
        }

        if (!(stack instanceof Error)) {
            throw new TypeError(UploadReason.ERROR_NO_STACK);
        }

        if (
            source !== UploadReason.SOURCE_BACKEND &&
            source !== UploadReason.SOURCE_WEB_BACKEND &&
            source !== UploadReason.SOURCE_WEB_CLIENT
        ) {
            throw new TypeError(UploadReason.ERROR_WRONG_SOURCE);
        }

        this.meta = {};

        this.timeStamp = Date.now();
        this.stack = stack;
        this.source = source;
        this.radarName = this.radarName.replace('{SOURCE}', source);
    }

    Object.assign(UploadReason, {
        ERROR_WRONG_INSTANCE: 'UploadReason called on non-instance of UploadReason',
        ERROR_ABSTRACT_CLASS: 'UploadReason is abstract class',
        ERROR_NO_STACK: 'UploadReason requires stack',
        ERROR_WRONG_SOURCE: 'wrong UploadReason source',

        SOURCE_BACKEND: 'backend',
        SOURCE_WEB_BACKEND: 'web-backend',
        SOURCE_WEB_CLIENT: 'web-client',
    });

    UploadReason.prototype = {
        constructor: UploadReason,

        /**
         * @type {string}
         */
        className: 'UploadReason',

        /**
         * @type {string}
         */
        radarName: 'reason_{SOURCE}_abstract',

        /**
         * @type {string}
         */
        message: 'Не загружено.',

        /**
         * Источник ошибки: backend, web-backend, web-client.
         * @type {string}
         */
        source: 'abstract',

        /**
         * @type {number}
         */
        timeStamp: -1,

        /**
         * Возможность повторить попытку.
         * @type {boolean}
         */
        isRetryable: false,

        /**
         * Ошибка для быстрой навигации по коду.
         * @type {Error}
         */
        stack: null,

        /**
         * uploadDescriptor.id
         * @type {string}
         */
        id: '',

        /**
         * @type {Object}
         */
        meta: null,

        /**
         * @type {string}
         */
        timePattern: 'hh:ss:mm.SSS(z)',

        /**
         * @type {string}
         */
        toStringPattern: '{MESSAGE}',

        toString: function () {
            var result = this.toStringPattern;

            result = result.replace('{MESSAGE}', this.message);

            return result;
        },

        /**
         * @param {string} id
         */
        setId: function (id) {
            this.id = id;
        },

        /**
         * @param {string} name
         * @param {string} value
         */
        setMeta: function (name, value) {
            this.meta[name] = value;
        },

        _getMetaString: function () {
            var meta = this.meta;
            var metaString = [];

            Object.keys(meta).forEach(function (name) {
                metaString.push(name + '=' + meta[name]);
            });

            return metaString.join(', ');
        },

        /**
         * @type {string}
         */
        toLogStringPattern: '[{TIME}] {ID} {SOURCE} {CLASS_NAME} { {META} }',

        toLogString: function () {
            var time = dateTime.format(this.timeStamp, this.timePattern);
            var result = this.toLogStringPattern;

            result = result.replace('{TIME}', time);
            result = result.replace('{ID}', this.id);
            result = result.replace('{SOURCE}', this.source);
            result = result.replace('{CLASS_NAME}', this.className);
            result = result.replace('{META}', this._getMetaString());

            return result;
        },

        /**
         * @returns {Object}
         */
        getDetails: function () {
            // TODO: add feature param: log stack to kaktam
            var details = {
                id: this.id,
                source: this.source,
                type: this.className,
                timeStamp: this.timeStamp,
                meta: this.meta,
            };

            return details;
        },
    };

    module.exports = UploadReason;
});
